
function push(data) {
    if (window.dataLayer && window.dataLayer.push) {
        console.info('pushing to gtm', data);
        window.dataLayer.push(data);
    } else {
        console.warn('gtm not ready');
    }
}

export { push };